const SUPPORTED_INPUT_TYPES = {
  textInput: "TEXTINPUT",
  boolean: "BOOLEAN",
  dropdown: "DROPDOWN",
  datepicker: "DATEPICKER",
  address: "ADDRESS",
  numeric: "NUMERIC",
  decimal: "DECIMAL",
  currency: "CURRENCY",
  radio: 'RADIO',
  textArea: 'TEXTAREA',
  country: 'COUNTRY',
};

const ADDRESS_SUB_TYPE_VALUES = {
  country: "country",
  line1: "line1",
  line2: "line2",
  zip: "zip",
  state: "state",
  city: "city",
};

const ADDRESS_LABELS = {
    [ADDRESS_SUB_TYPE_VALUES.line1]: `Address`,
    [ADDRESS_SUB_TYPE_VALUES.line2]: `Address Line 2`,
    [ADDRESS_SUB_TYPE_VALUES.state]: `State / Territory`,
    [ADDRESS_SUB_TYPE_VALUES.zip]: `Postal Code`,
    [ADDRESS_SUB_TYPE_VALUES.country]: `Country`,
    [ADDRESS_SUB_TYPE_VALUES.city]: `City`
}

const ADDRESS_DESCRIPTIONS = {
    [ADDRESS_SUB_TYPE_VALUES.line1]: `Please provide the full street address.`
}

const intents = {
  save: "save",
  delete: "delete",
  submit: "submit",
  accept: "accept",
};

const titles = {
  [intents.save]: `Form Saved Successfully`,
  [intents.delete]: `Form Deleted Successfully`,
  [intents.submit]: `Form Submitted Successfully`,
  [intents.accept]: `Form Reported Successfully`,
};

const keyIdentifiers = {
  id: "form#id",
  type: "form#type",
  intent: "form#intent",
};

const HTML_FORM_CONSTANTS = {
  INTENTS: intents,
  TITLES: titles,
  IDS: keyIdentifiers,
}


export {
  SUPPORTED_INPUT_TYPES,
  ADDRESS_SUB_TYPE_VALUES,
  ADDRESS_LABELS,
  HTML_FORM_CONSTANTS,
  ADDRESS_DESCRIPTIONS
};